import { useState } from "react"
import mainservice from "../../../services/MainService"
import UserDisplayById from "../../../components/User/UserDisplayById"
import { Box, Button, Stack } from "@mui/material"
import { RightDrawerContent } from "../RightDrawer"
import { GLItemDTO } from "../../../DTO/GLItemDTO"

export default function LogChatResponsibility ({
  glitem,
  className = '',
}: {
  glitem: GLItemDTO,
  className?: string,
}) {
  const [userId, setUserId] = useState(glitem.getAssigneeId())
  const broadcastSelectUserKey = `Responsibility-chg-usr-${glitem.id}`
  mainservice.registerToBroadcast(broadcastSelectUserKey,
    (key: string, value: {userId: number}) => {
      if (key !== broadcastSelectUserKey) {return}
      if (value.userId < 0) {return}
      setUserId(value.userId)
      glitem.setAssigneeId(value.userId)
    }
  )
  return <Stack
    direction='column'
    spacing={2}
    className={className}
  >
    <Box>
      <UserDisplayById id={userId} />
    </Box>
    <Box>
      <Button
        variant='outlined'
        onClick={() => {
          mainservice.broadcast('rightDrawerOpen', {
            contentType: RightDrawerContent.selectResponsibleForCustomer,
            broadCastBackKey: broadcastSelectUserKey,
          })
        }}
      >
        Verantwortlichen wählen
      </Button>
    </Box>
  </Stack>
}
